import classNames from "classnames";
import { Duration, LocalTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { formatDuration } from "../../../utils/dateUtils";
import { CLOCK_IN_ICON_SVG, CLOCK_OUT_ICON_SVG, CLOCK_SVG } from "../../../utils/svgs";
import { AppIcon } from "../../Generic/AppIcon";
import { AppListItem } from "../../Generic/AppList";
import Flex from "../../Generic/Flex";
import TimePicker from "../../Generic/TimePicker/TimePicker";

interface ChooseTimesheetClockTimesProps {
  clockedInAt: LocalTime | null;
  clockedOutAt: LocalTime | null;
  isDurationDanger: boolean;
  onChooseClockInTime: (localTime: LocalTime | null) => void;
  onChooseClockOutTime: (localTime: LocalTime | null) => void;
}

function ChooseTimesheetClockTimes(props: ChooseTimesheetClockTimesProps) {
  return (
    <Flex direction="column" yGap={8} className="ChooseTimesheetClockTimes">
      <AppListItem
        leading={<AppIcon icon={CLOCK_IN_ICON_SVG} />}
        title={<span>{translate(STRINGS.CLOCK_IN)}</span>}
        trailing={<TimePicker value={props.clockedInAt} onChange={props.onChooseClockInTime} />}
      />
      <AppListItem
        leading={<AppIcon icon={CLOCK_OUT_ICON_SVG} />}
        title={<span>{translate(STRINGS.CLOCK_OUT)}</span>}
        trailing={<TimePicker value={props.clockedOutAt} onChange={props.onChooseClockOutTime} />}
      />
      <AppListItem
        leading={<AppIcon icon={CLOCK_SVG} />}
        title={translate(STRINGS.DURATION)}
        trailing={
          <span className={classNames("duration", { red: props.isDurationDanger })}>
            {props.clockedInAt !== null && props.clockedOutAt !== null
              ? formatDuration(Duration.between(props.clockedInAt, props.clockedOutAt), "")
              : ""}
          </span>
        }
      />
    </Flex>
  );
}

export default ChooseTimesheetClockTimes;
